import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import teamService from '../services/teamService';

export const TEAM_KEY = ['attorney', 'team'];

/**
 * Hook to fetch team members and invitations
 */
export function useTeam(options = {}) {
  return useQuery({
    queryKey: TEAM_KEY,
    queryFn: () => teamService.getTeam(),
    staleTime: 1000 * 60 * 2, // 2 minutes
    enabled: options.enabled !== false
  });
}

/**
 * Hook to invite a new member
 */
export function useInviteMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ email, role }) => teamService.inviteMember(email, role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_KEY });
    }
  });
}

/**
 * Hook to cancel an invitation
 */
export function useCancelInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId) => teamService.cancelInvitation(invitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_KEY });
    }
  });
}

/**
 * Hook to remove a member
 */
export function useRemoveMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId) => teamService.removeMember(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_KEY });
    }
  });
}

export default {
  useTeam,
  useInviteMember,
  useCancelInvitation,
  useRemoveMember
};
